<template>
    <div class="product-slider">
        <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for="(product, key) in products" :key="key">
                <div class="product__inner">
                    <div class="product__leftside">
                        <a href="#" class="acer-logo">
                            <img src="/static/img/pages/product/acer-logo.png" alt="acer">
                        </a>
                        <div class="product__img">
                            <img :src="product.mainImg" :alt="product.mainImg">
                        </div>
                        <div class="product__content product__content--nomg">
                            <h2 class="product__name">
                                <span v-html="product.name"></span>
                            </h2>
                            <h3 class="product__price">
                                <span v-html="product.price"></span>
                            </h3>
                            <a :href="product.link" target="_blank" class="product__link btn" @click="$root.gaSend('product', 'click', product.name)">Купить</a>
                        </div>
                    </div>
                    <div class="product__rightside" :style="{'backgroundImage': ($root.isMobile)?'url('+bg+')':''}">
                        <div class="product__content">
                            <h1 class="product__title">
                                <span v-html="product.title"></span>
                            </h1>
                            <p class="product__description" v-html="product.description"></p>
                        </div>
                        <div class="product__features">
                            <div class="product__features-item" v-for="(item, index) in product.features" :key="index">
                                <img :src="'/static/svg/icons/'+item.img+'.svg'" alt="icon" v-if="item.img">
                                <h3 class="item-title" v-if="item.title">
                                    <span v-html="item.title"></span>
                                </h3>
                                <h4 class="item-undertitle" v-if="item.description">
                                    <span v-html="item.description"></span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="next-slide" v-if="$root.isMobile">
            <arrow-next></arrow-next>
        </div>
        <div class="prev-slide" v-if="$root.isMobile">
            <arrow-prev></arrow-prev>
        </div>
        <div class="product__navigation navi" v-if="!$root.isMobile">
            <div class="navi__leftside">
                <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
            </div>
            <div class="navi__rightside">

            </div>
        </div>
    </div>
</template>

<script>
    import products from '@/configs/products.js';
    import icons from '@/assets/svg/icons';
    import {mapGetters} from 'vuex';

    export default {
        name: 'ProductSlider',
        props: ['bg'],
        data() {
            const self = this;
            return {
                products,
                swiperOption: {
                    speed: 600,
                    loop: false,
                    effect: 'slide',
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        renderBullet(index, className) {
                            return `<div class="${className} swiper-pagination-bullet-custom"><div class="nav-image"><img src="${self.products[index].secondaryImg}"></div><span class="nav-title">${self.products[index].name}</span></div>`
                        }
                    },
                    on: {
                        slideChange(index) {
                            self.$store.commit('updateCurrentBg', self.products[this.activeIndex].bg);
                            self.$router.push(self.products[this.activeIndex].param);
                            self.$root.gaSend('product', 'click', self.products[this.activeIndex].param);
                        },
                        init() {
                            self.$store.commit('updateCurrentBg', self.products[this.activeIndex].bg);
                            self.$root.gaSend('product', 'how', self.$route.params.id);
                            self.updCurrentSlide(self.$route.params.id, this);
                        }
                    },
                    breakpoints: {
                        1023: {
                            loop: false,
                            pagination: {
                                el: null
                            },
                            navigation: {
                                nextEl: '.next-slide',
                                prevEl: '.prev-slide'
                            }
                        }
                    }
                }
            }
        },
        methods: {
            updCurrentSlide(id, swiper) {
                products.forEach(item => {
                    if (item.param == id) {
                        swiper.slideTo(products.indexOf(item));
                    }
                });
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        components: {
            'arrow-next': icons.arrowNext,
            'arrow-prev': icons.arrowPrev,
        },
        watch: {
            '$route'(to, from) {
                this.$root.gaSend('product', 'click', to.params.id);
                this.updCurrentSlide(to.params.id, this.swiper);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// productSlider.vue?74e24499